import React from "react";

interface HeartIconProps {
  width?: number;
  height?: number;
  fillColor?: string;
}

export const HeartIcon: React.FC<HeartIconProps> = ({
  width = 14,
  height = 12,
  fillColor = "#FFE9D9",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.28923 12C7.23959 12 7.18995 11.9848 7.14032 11.9596C6.87228 11.798 0.583374 7.90909 0.583374 3.73232C0.588338 1.67677 2.26604 0 4.32594 0C5.49239 0 6.58935 0.555556 7.29419 1.47475C7.99406 0.555556 9.09598 0 10.2624 0C12.3273 0 14 1.67677 14 3.73232C14 7.90909 7.7161 11.7929 7.4431 11.9596C7.39843 11.9899 7.34879 12 7.29419 12H7.28923Z"
        fill={fillColor}
      />
      <path
        d="M6.70585 11.8537C6.68702 11.8537 6.66178 11.8481 6.6277 11.8314C6.4671 11.7339 4.85592 10.7331 3.27837 9.24518C2.48094 8.49305 1.69595 7.62001 1.11109 6.67988C0.525951 5.73929 0.146385 4.74005 0.146341 3.7325C0.151207 1.75766 1.76346 0.146341 3.74257 0.146341C4.86245 0.146341 5.9169 0.679875 6.59468 1.5638L6.71123 1.71578L6.82725 1.5634C7.4998 0.680092 8.55888 0.146341 9.67906 0.146341C11.6631 0.146341 13.2703 1.75762 13.2703 3.73232C13.2703 4.73995 12.891 5.73895 12.3063 6.67918C11.7218 7.61891 10.9373 8.49147 10.1402 9.24329C8.5458 10.747 6.91642 11.7535 6.78347 11.8347L6.78338 11.8345L6.77757 11.8385C6.76474 11.8472 6.7469 11.8537 6.71081 11.8537H6.70585Z"
        stroke="#1A1A1A"
        stroke-width="0.292683"
      />
      <path
        d="M6.70585 11.8537C6.68702 11.8537 6.66178 11.8481 6.6277 11.8314C6.4671 11.7339 4.85592 10.7331 3.27837 9.24518C2.48094 8.49305 1.69595 7.62001 1.11109 6.67988C0.525951 5.73929 0.146385 4.74005 0.146341 3.7325C0.151207 1.75766 1.76346 0.146341 3.74257 0.146341C4.86245 0.146341 5.9169 0.679875 6.59468 1.5638L6.71123 1.71578L6.82725 1.5634C7.4998 0.680092 8.55888 0.146341 9.67906 0.146341C11.6631 0.146341 13.2703 1.75762 13.2703 3.73232C13.2703 4.73995 12.891 5.73895 12.3063 6.67918C11.7218 7.61891 10.9373 8.49147 10.1402 9.24329C8.5458 10.747 6.91642 11.7535 6.78347 11.8347L6.78338 11.8345L6.77757 11.8385C6.76474 11.8472 6.7469 11.8537 6.71081 11.8537H6.70585Z"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="0.292683"
      />
      <path
        d="M6.70585 11.8537C6.68702 11.8537 6.66178 11.8481 6.6277 11.8314C6.4671 11.7339 4.85592 10.7331 3.27837 9.24518C2.48094 8.49305 1.69595 7.62001 1.11109 6.67988C0.525951 5.73929 0.146385 4.74005 0.146341 3.7325C0.151207 1.75766 1.76346 0.146341 3.74257 0.146341C4.86245 0.146341 5.9169 0.679875 6.59468 1.5638L6.71123 1.71578L6.82725 1.5634C7.4998 0.680092 8.55888 0.146341 9.67906 0.146341C11.6631 0.146341 13.2703 1.75762 13.2703 3.73232C13.2703 4.73995 12.891 5.73895 12.3063 6.67918C11.7218 7.61891 10.9373 8.49147 10.1402 9.24329C8.5458 10.747 6.91642 11.7535 6.78347 11.8347L6.78338 11.8345L6.77757 11.8385C6.76474 11.8472 6.7469 11.8537 6.71081 11.8537H6.70585Z"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="0.292683"
      />
      <path
        d="M6.70585 11.8537C6.68702 11.8537 6.66178 11.8481 6.6277 11.8314C6.4671 11.7339 4.85592 10.7331 3.27837 9.24518C2.48094 8.49305 1.69595 7.62001 1.11109 6.67988C0.525951 5.73929 0.146385 4.74005 0.146341 3.7325C0.151207 1.75766 1.76346 0.146341 3.74257 0.146341C4.86245 0.146341 5.9169 0.679875 6.59468 1.5638L6.71123 1.71578L6.82725 1.5634C7.4998 0.680092 8.55888 0.146341 9.67906 0.146341C11.6631 0.146341 13.2703 1.75762 13.2703 3.73232C13.2703 4.73995 12.891 5.73895 12.3063 6.67918C11.7218 7.61891 10.9373 8.49147 10.1402 9.24329C8.5458 10.747 6.91642 11.7535 6.78347 11.8347L6.78338 11.8345L6.77757 11.8385C6.76474 11.8472 6.7469 11.8537 6.71081 11.8537H6.70585Z"
        stroke="black"
        stroke-opacity="0.2"
        stroke-width="0.292683"
      />
    </svg>
  );
};


